module.exports = __webpack_public_path__ + "img/question5.352dba2f.png";